import { createFileRoute } from "@tanstack/react-router";
import GeoUK from "@/pages/GeoUK";
import {
  buildPageHead,
  breadcrumbSchema,
  serviceSchema,
  faqPageSchema,
} from "@/lib/seo";

const faqs = [
  {
    question: "Can I hire a RevOps specialist for a UK business?",
    answer:
      "Yes. Marjohn is a Philippines-based Revenue Operations specialist with strategic GMT/BST timezone overlap for UK businesses, delivering high-end technical automation and CRM engineering without local UK rates.",
  },
  {
    question: "Why hire a RevOps specialist from the Philippines for the UK?",
    answer:
      "Hiring from the Philippines gives UK businesses senior-grade RevOps engineering at a fraction of local rates, with direct contractor engagement, GMT/BST timezone overlap, and no agency markups.",
  },
  {
    question: "How much does it cost to hire a RevOps specialist for the UK?",
    answer:
      "Engagements are scoped per project or retainer. Marjohn works as a remote contractor paid via low-fee cross-border transfers such as Wise. Book a free strategy call to receive a custom scope and quote.",
  },
  {
    question: "What timezone overlap do you offer with the UK?",
    answer:
      "Marjohn offers strategic overlap with GMT/BST business hours, so UK businesses get real-time collaboration and direct communication during their working day.",
  },
];

export const Route = createFileRoute("/revops-specialist-uk")({
  head: () =>
    buildPageHead({
      title: "RevOps Specialist UK | Marjohn Robillo",
      description:
        "Hire an elite RevOps Specialist from the Philippines for your UK-based business. Strategic timezone overlap and high-end technical automation.",
      path: "/revops-specialist-uk",
      keywords:
        "RevOps specialist UK, revenue operations UK, technical VA UK, Philippines RevOps, UK agency automation, CRM specialist UK",
      hreflang: [
        {
          hreflang: "en-US",
          href: "https://marjohnrobillo.me/hire-technical-va-usa",
        },
        {
          hreflang: "en-GB",
          href: "https://marjohnrobillo.me/revops-specialist-uk",
        },
        {
          hreflang: "en-AU",
          href: "https://marjohnrobillo.me/ghl-automation-expert-australia",
        },
        { hreflang: "x-default", href: "https://marjohnrobillo.me/" },
      ],
      schema: [
        serviceSchema({
          name: "RevOps Specialist for UK Businesses",
          description:
            "Revenue operations specialist with strategic timezone overlap and high-end technical automation for UK businesses.",
          path: "/revops-specialist-uk",
          serviceType: [
            "Revenue Operations",
            "CRM Automation",
            "Sales Ops Engineering",
          ],
          areaServed: ["United Kingdom", "Ireland"],
        }),
        breadcrumbSchema([
          { name: "Home", path: "" },
          { name: "RevOps Specialist UK", path: "/revops-specialist-uk" },
        ]),
        faqPageSchema(faqs),
      ],
    }),
  component: GeoUK,
});
